export default function extractParentProject(projects) {
  const parentProjectList = []
  projects.filter((project) => {
    if (project.parent === undefined) {
      parentProjectList.push(project)
    }
  })
  return parentProjectList
}
